import { FileIdsValue, SelectMultipleValue } from '@kaizenplatform/hugot-entity';
import { createElement, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { DynamicSchemaDefinitionMultiLineText } from '../../../../../generated/graphql';
import { AfterValueText, BeforeValueText } from '../../../primitive/DiffText';
import LfToBr from '../../../primitive/LfToBr';
import { Label, LabelAndValue, Value, ValueText } from '../../ProjectBasicSettingDetail';

interface Props {
  field: Pick<DynamicSchemaDefinitionMultiLineText, 'key'>;
  value: Map<string, string | number | boolean | SelectMultipleValue | FileIdsValue | null>;
  beforeValue?: Map<string, string | number | boolean | SelectMultipleValue | FileIdsValue | null>;
}

const AsMultiLineText = ({ field, value, beforeValue }: Props) => {
  const option = value.get(field.key) as string;
  const beforeOption = beforeValue != null ? (beforeValue.get(field.key) as string) : '';

  return (
    <LabelAndValue>
      <Label>
        <FormattedMessage id="project_basic_setting_detail.assets.label.option" />
      </Label>
      <Value>
        {beforeValue == null || option === beforeOption ? (
          <ValueText>
            {option !== '' ? <LfToBr text={option} /> : <FormattedMessage id="creative_brief_detail.field.empty" />}
          </ValueText>
        ) : (
          <>
            <BeforeValueText>
              {beforeOption !== '' ? (
                <LfToBr text={beforeOption} />
              ) : (
                <FormattedMessage id="creative_brief_detail.field.empty" />
              )}
            </BeforeValueText>
            <AfterValueText>
              {option !== '' ? <LfToBr text={option} /> : <FormattedMessage id="creative_brief_detail.field.empty" />}
            </AfterValueText>
          </>
        )}
      </Value>
    </LabelAndValue>
  );
};

export default AsMultiLineText;
